import * as React from "react";
import { computed, observable } from "mobx"
import { observer } from "mobx-react";
import { newGuid } from "../Utilities";
import { Strings } from "../Stores/StringsStore";
import { DialogStore } from "../Stores/DialogStore";

const BYTES_PER_CHUNK = 1024 * 1024;

export interface IFileUploadProps {
	onloadstart: () => void;
	onfileupload: (file: FileUploadInfo) => void;
	onloadend: () => void;
	multiple: boolean;
	testId?: string;
}

export class FileUploadInfo {
	guid: string;
	originalName: string;
	size: number;
	mimeType: string;
}

class FileUploadProgressData {
	file: File;
	onfileupload: (fileUploadInfo: FileUploadInfo) => void;
	progressList: FileUploadProgressData[] = [];
}

@observer
export class FileUpload extends React.Component<IFileUploadProps, {}> {

	@observable progressList: FileUploadProgressData[] = [];
	files: number;

	handleFileDeleted = () => {
		let fileInput = this.refs.input;
		fileInput.value = "";
	}

	private handleFileChanged = () => {
		this.props.onloadstart();

		let fileInput = this.refs.input;

		this.files = 0;

		for (let i = 0; i < fileInput.files.length; i++) {
			let match = fileInput.files[i].name.match("\.[a-zA-Z0-9]+$");
			let extension = match.length > 0 ? match[0] : "";
			extension = extension.toLowerCase();
			let progressData = new FileUploadProgressData();
			progressData.file = fileInput.files[i];
			progressData.onfileupload = fileUploadInfo => {
				this.props.onfileupload(fileUploadInfo);
				this.files++;

				// Check for end of upload all files
				if (this.files == fileInput.files.length) {
					this.props.onloadend();
				}

				// Remove file for progress items
				for (let j = 0; j < this.progressList.length; j++) {
					if (this.progressList[j].file.name == fileUploadInfo.originalName) {
						this.progressList.splice(j, 1);
						break;
					}
				}
			};

			// push progress bar to list
			this.progressList.push(progressData);
		}
	}

	click = () => {
		this.refs.input.click();
	}

	refs: {
		[key: string]: Element;
		input: HTMLInputElement;
	}

	render() {
		return <div>
			<input ref="input" type="file" size={10} onChange={this.handleFileChanged} multiple={this.props.multiple} className="hide" data-test-id={this.props.testId} />
			{this.progressList.map(item => {
				return <FileUploadProgress key={item.file.name} file={item.file} onfileupload={item.onfileupload} progressList={this.progressList} />
			})}
		</div>;
	}
}

@observer
class FileUploadProgress extends React.Component<FileUploadProgressData, {}> {
	guid: string;
	@observable filename = "";
	@observable bytesLoaded = 0;
	@observable bytesTotal = 0;

	componentDidMount() {
		let file = this.props.file;

		this.guid = newGuid();
		this.bytesLoaded = 0;
		this.bytesTotal = file.size;

		this.upload(file, 0, Math.min(file.size, BYTES_PER_CHUNK), file.size);
	}

	@computed get percentage(): number {
		return this.bytesTotal > 0 ? Math.round((this.bytesLoaded / this.bytesTotal) * 100) : 0;
	}

	upload(file: File, start: number, end: number, total: number) {

		let me = this;

		let blob = file.slice(start, end);

		var xhr = new XMLHttpRequest();
		xhr.open('POST', '/upload', true);
		xhr.setRequestHeader("Content-Type", file.type);
		xhr.setRequestHeader("x-guid", me.guid);
		xhr.setRequestHeader("x-filename", file.name.replace(/[^\x00-\x7F]/g, ""));
		xhr.setRequestHeader("x-start", start.toString());
		xhr.setRequestHeader("x-end", end.toString());
		xhr.setRequestHeader("x-total", total.toString());

		let lastLoaded = 0;
		xhr.upload.onprogress = function (e) {

			me.bytesLoaded = me.bytesLoaded - lastLoaded + e.loaded;
			lastLoaded = e.loaded;
			//me.forceUpdate();
		};

		xhr.onloadend = function (e) {
			if (end < file.size) {
				start = end;
				end = start + Math.min(BYTES_PER_CHUNK, file.size - start);
				me.upload(file, start, end, total);
			}
			else if (xhr.status === 200) {
				let fileUploadInfo = new FileUploadInfo();
				fileUploadInfo.guid = me.guid;
				fileUploadInfo.originalName = file.name;
				fileUploadInfo.size = file.size;
				fileUploadInfo.mimeType = file.type;
				me.props.onfileupload(fileUploadInfo);
			}
			else {
				DialogStore.showError(Strings.general.errorDialogTitle, xhr.responseText);
				let index = me.props.progressList.indexOf(me.props);
				me.props.progressList.splice(index, 1);
			}
			//me.forceUpdate();
		}

		xhr.send(blob);
	}

	render() {
		var barStyle = {
			'maxWidth': this.percentage + '%'
		};

		return <div className="fileupload">
			<span className="fileupload__name">{this.filename}</span>
			<div className="fileupload__progressbar">
				<div className="fileupload__progressbar-progress" style={barStyle}>
					<span>{this.percentage}% | <b>{Math.ceil(this.bytesLoaded / 1024)} / {Math.ceil(this.bytesTotal / 1024)} kB</b></span>
				</div>
			</div>
		</div>;
	}
}